/** Slug da clínica no portal cliente — configurável por instalação */
export const CLINIC_SLUG = import.meta.env.VITE_CLINIC_SLUG ?? 'demo-clinica';
